import { Typography } from 'antd'
import { SyncOutlined } from '@ant-design/icons'

interface Props {
  updatedAt: number | null
}

export function AutoRefreshBadge({ updatedAt }: Props) {
  if (!updatedAt) return null
  const time = new Date(updatedAt).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })
  return (
    <Typography.Text type="secondary" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
      <SyncOutlined style={{ marginRight: 4, fontSize: 11 }} />
      Aggiornato alle {time}
    </Typography.Text>
  )
}
